import React from 'react'

import { getSpecialPartnership } from '@mc/sessions-utils'

import Image from 'components/LegacyImage'
import { useSessionsLandingPageData } from 'pages/sessions/classes/[slug]/components/SessionsLandingPageDataProvider'

import style from './SpecialPartnership.module.scss'

export const SpecialPartnership = () => {
  const {
    camp: { slug },
  } = useSessionsLandingPageData()
  const currentPartnership = getSpecialPartnership(slug)

  if (!currentPartnership) return <></>

  return (
    <section className='container d-flex flex-column mc-my-12'>
      <div className='row no-gutters justify-content-center'>
        <div className='col-12 col-lg-8'>
          <h2 className='mc-text-h1 mc-text--center mc-pb-9'>
            {currentPartnership.title}
          </h2>
        </div>
      </div>
      <div
        className={`${style.container} row no-gutters mc-corners--sm mc-overflow--hidden align-self-center`}
      >
        <div
          className={`${style.image} d-flex flex-column align-items-center col-lg-3 col-md-12 col-sm-12`}
        >
          <Image
            src={currentPartnership.image}
            alt=''
            layout='fill'
            className={`d-block ${style.partnershipImage}`}
          />
        </div>
        <div className='col-lg-9 col-md-12 col-sm-12 align-self-center'>
          <div className='mc-py-10 mc-px-9'>
            <p>{currentPartnership.description}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
